/********************************************************************
 * tiny-slider.js
 *
 * Die Lazyload-Implementierung von tinly-slider mit data-srcset ist im IE 11 fehlerhaft umgesetzt:
 * https://github.com/ganlanyuan/tiny-slider/issues/322
 *
 * Die Bilder werden bei tiny-slider tatsächlich erst beim Sliderwechsel geladen. Hierbei gibt
 * es unschöne Effekte im ersten Durchlauf. Insbedondere wenn der User manuell wechselt.
 *
 * Beide Probleme werden durch den Einsatz von lazysizes behoben.
 * https://github.com/aFarkas/lazysizes
 */

import { tns } from 'tiny-slider/src/tiny-slider'

// create global tns variable
global.tns = tns;